import { ca } from '@cian/analytics';

export function trackSerpLinkClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Auction_block',
    action: 'Click',
    label: 'offers_in_location',
  });
}
